/* 黃忠（字漢升） */
import { defineHero } from '../define.ts';

export default defineHero({
  id: 'huangzhong', name: '黃忠', sub: '字漢升', faction: 'shu', role: '射手', weapon: 'bow',
  look: { hair: '#e9e5dc', beard: 'long', fx: '#ffd46b', c: { pole: '#6b3b24' } },
  skills: [
    ['箭術', 'buff', '攻速 +{30/45/60/75}%，持續 10 秒。', { x: { k: 'buff', as: [30, 45, 60, 75], dur: 10 }, cd: 20, mp: 115 }],
    ['火箭矢', 'buff', '開關技（按一下開啟、再按一下關閉）。開啟時箭矢點火：每次普攻附加 {12/20/28/36} 火焰傷害並點燃目標，每發耗 {8/10/12/14} 氣；氣不夠時射出普通的箭。', { tg: { orb: [12, 20, 28, 36], mp: [8, 10, 12, 14] }, mp: 0, el: 'fire' }],
    ['精準之光', 'passive', '基本攻擊力 +{6/9/12/15}%。', { pv: { atkP: [6, 9, 12, 15] } }],
    ['百步穿楊', 'bolt', '瞄準 1.5 秒後射出致命一箭，造成 {280/360/440} 傷害，射程隨等級大幅增加。', { x: { k: 'nuke', dmg: [280, 360, 440], delay: 1.5, pick: 170, at: 0.5 }, aim: { kind: 'point', range: [960, 1360, 1760], area: 60 }, cd: 110, mp: [140, 160, 180] }],
  ],
});
